var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionsUserIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.524 18.072a8.396 8.396 0 0 0-11.59-11.591c-.866.048-1.724.2-2.554.45a9.732 9.732 0 0 1 2.148-1.716 9.642 9.642 0 0 1 4.878-1.335h.032c5.35 0 9.688 4.337 9.688 9.688 0 .087-.001.173-.003.26l-.002.03a9.637 9.637 0 0 1-1.33 4.62 9.732 9.732 0 0 1-1.717 2.148c.246-.816.4-1.671.45-2.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.641 14.638a.646.646 0 1 1-1.217.43 1.293 1.293 0 0 0-1.219-.86v2.583a2.583 2.583 0 0 1 0 5.166v.646h-1.292v-.646a2.584 2.584 0 0 1-2.436-1.722.646.646 0 1 1 1.218-.43c.178.502.656.86 1.218.86v-2.583a2.583 2.583 0 1 1 0-5.166v-.646h1.292v.646a2.584 2.584 0 0 1 2.436 1.722zm-3.728-.43a1.292 1.292 0 0 0 0 2.583zm1.292 6.458a1.292 1.292 0 1 0 0-2.584z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.255 17.438c0 5.35-4.337 9.687-9.688 9.687-5.35 0-9.687-4.337-9.687-9.688 0-5.35 4.337-9.687 9.688-9.687 5.35 0 9.687 4.337 9.687 9.688zm-9.687-8.396a8.396 8.396 0 0 0-8.396 8.396 8.396 8.396 0 0 0 8.396 8.395 8.396 8.396 0 0 0 8.395-8.395 8.396 8.396 0 0 0-8.396-8.396z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsUserIcon01);
export default __webpack_public_path__ + "static/media/actions-user_icon_01.a77d47a40262a7ee1a74219d554c336d.svg";
export { ForwardRef as ReactComponent };